import {
  ResidentDto,
  Resident,
  DetailedResidentDto,
  DetailedResident,
} from '$domain/model/nursingHome/residents/residents.model'

const mapNames = (resident: ResidentDto) => {
  if (resident && resident.name && resident.surnames) {
    const fullName = resident.name + ' ' + resident.surnames
    const splitName = fullName.split(' ')
    const capitalizedName = splitName.map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
    return capitalizedName
  }

  return ''
}

export const mapResidentsList = (residents: ResidentDto[]): Resident[] => {
  return residents.map(resident => {
    return {
      id: resident.id || '',
      name: mapNames(resident),
    }
  })
}

export const mapDetailedResidentsList = (residents: DetailedResidentDto[]): DetailedResident[] => {
  return residents.map(resident => {
    return {
      id: resident.id || '',
      dni: resident.dni || '',
      name: resident.name || '',
      surnames: resident.surnames || '',
      lastCardNumbers: resident.lastCardNumbers || '',
      active: resident.active ? resident.active : false,
    }
  })
}



// WEBPACK FOOTER //
// ./src/domain/model/nursingHome/residents/residents.mapper.ts